import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../../providers';

@Component({
  selector: 'auth-microsoft-auth-complete',
  templateUrl: './microsoft-auth-complete.component.html',
})
export class MicrosoftAuthCompleteComponent implements OnInit {
  constructor(
    private msalService: MsalService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.msalService.instance.handleRedirectPromise().then((result) => {
      if (result) {
        this.msalService.instance.setActiveAccount(result.account);
        this.authService.exchangeIdToken(result.idToken);
      } else {
        window.location.href = '/login';
      }
    }).catch((error) => {
      console.error('Error en Microsoft Auth Complete:', error);
      window.location.href = '/login';
    });
  }
}

